import React from "react";
import "../../../css/MonthSubsc.css";
import mobility from "../../../img/ride.png";

interface MonthSubscProps {
  ThisMonth: string;
  LastMonth: string;
}

const MonthSubsc = ({ ThisMonth, LastMonth }: MonthSubscProps) => {
  return (
    <div className="subsc_month_container">
      <div className="subsc_display">
        <img className="mobility" src={mobility} />
        <div className="subsc_month_title">今月の登録者数</div>
      </div>
      <div className="subsc_month_of">
        {ThisMonth} <span className="unit">人</span>
      </div>
      <div className="subsc_last_month">
        先月の登録者数:
        <span className="subsc_last_month_number">
          {LastMonth}
          <span className="unit">人</span>
        </span>
      </div>
    </div>
  );
};

export default MonthSubsc;
